import {
    IntegratedFiltering,
    IntegratedPaging,
    IntegratedSorting,
    PagingState,
    SortingState,
    TableColumnResizing,
} from '@devexpress/dx-react-grid';
import {
    DragDropProvider,
    Grid,
    PagingPanel,
    Table,
    TableColumnReordering,
    TableHeaderRow,
} from '@devexpress/dx-react-grid-material-ui';
import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import { LinearProgress } from 'material-ui';
import CheckIcon from 'material-ui-icons/Check';
import Paper from 'material-ui/Paper';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Link from 'react-router-dom/Link';
import { reduxForm } from 'redux-form';
import addEditCustomerGroup from '../../../actions/addEditCustomerGroup';
import getCustomerGroups from '../../../actions/getCustomerGroups';
import compareCaseInsensitive from '../../../helpers/CompareCaseInsensitive';
import SimpleMenu from '../../../helpers/SimpleMenu';
import SkeletonTableRows from '../../../helpers/SkeletonTableRows';
import TableFilters from '../../../helpers/TableFilters';
import { cacheTableOptions, getTableOptions, isUserATSysAdmin } from '../../../helpers/Util';
import Layout from '../../Layout';
import OverflowTip from '../../../helpers/OverflowTip';


const componentKey = 'customer-group-list';
const paperStyle = {
    width: '80%',
    height: '70%',
    display: 'inline-block',
    margin: 20,
    marginTop: '4vh'
};


class CustomerGroupList extends Component {
    constructor(props) {
        super(props);
    
        const columns = [
                { name: 'isActive', title: 'Active' },
                { name: 'customerGroupName', title: 'Customer Group Name' },
                { name: 'customerGroupDesc', title: 'Group Description' },
                { name: 'customerGroupType', title: 'Group Type' },
                { name: 'customerCount', title: 'Customers' },
                { name: 'menu', title: ' ' },
            ];
        const skeletonRows = SkeletonTableRows({ columns: columns, rowKey: 'customerGroupId' });
    
        this.state = {
            addLink: '/add-edit-customer-group',
            anchorEl: null,
            columns: columns,
            columnOrder: ['isActive', 'customerGroupName', 'customerGroupDesc', 'customerGroupType', 'customerCount', 'menu',],
            columnWidths: [
                { columnName: 'isActive', width: '9.9%' },
                { columnName: 'customerGroupName', width: '24.75%' },
                { columnName: 'customerGroupDesc', width: '29.7%' },
                { columnName: 'customerGroupType', width: '15.84%' },
                { columnName: 'customerCount', width: '9.9%' },
                { columnName: 'menu', width: '9.9%' },
            ],
            currentPage: 0,
            allItems: [],
            fetching: false,
            filterByOptions: [
                { name: 'all', label: 'All' },
                { name: 'active', label: 'Active' },
                { name: 'inactive', label: 'Inactive' },
            ],
            initialValues: {},
            loading: false,
            pageSize: 10,
            pageSizes: [5, 10, 0],
            rows: skeletonRows,
            searchByOptions: [
                { name: 'customerGroupName', label: 'Customer Group Name' },
                { name: 'customerGroupDesc', label: 'Group Description' },
                { name: 'customerGroupType', label: 'Group Type' }
            ],
            sorting: [{ columnName: 'customerGroupName', direction: 'asc'}],
            tableColumnExtensions: [
                { columnName: 'customerGroupDesc', wordWrapEnabled: true }
            ],
            title: 'Customer Groups',
        };
    }

    async componentDidMount() {
        if (this.props.customerGroups && this.props.customerGroups.customerGroups &&
            this.props.customerGroups.customerGroups.customerGroups.length > 0) {
            await this.getCustomerGroupData();
        } else {
            await this.props.actions.getCustomerGroups(this.props.config);
            if (this.props.customerGroups && this.props.customerGroups.customerGroups &&
                this.props.customerGroups.customerGroups.customerGroups.length > 0) {
                await this.getCustomerGroupData();
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.customerGroups !== this.props.customerGroups) {
            if (this.props.customerGroups && this.props.customerGroups.customerGroups &&
                this.props.customerGroups.customerGroups.customerGroups.length > 0) {
                this.getCustomerGroupData();
            }
        }
    }       

    getCustomerGroupData = async () => {
        if (this.props.customerGroups && this.props.customerGroups.customerGroups &&
            this.props.customerGroups.customerGroups.customerGroups.length > 0) {
            this.props.actions.getCustomerGroupData(this.props.customerGroups.customerGroups.customerGroups, this);
        }
    }
    
    reapplyTableOptions = () => {
        const tableOptions = getTableOptions(componentKey);
        if (!tableOptions) return;
        
        this.setState({ ...tableOptions });
        this.changeFilters(tableOptions.initialValues);
    };
    
    rowMapper = (row) => ({
        isActive: (row.isActive === undefined || row.isActive === null) ? true : row.isActive,
        ...row,
    });
    
    getRowId = (row) => {
        return row.customerGroupId
    };
    
    changeCurrentPage = (currentPage) => {
        cacheTableOptions(componentKey, { currentPage });
        this.setState({ currentPage });
    };
    
    changePageSize = (pageSize) => {
        cacheTableOptions(componentKey, { pageSize });
        this.setState({ pageSize });
    };
    
    changeColumnOrder = (columnOrder) => {
        cacheTableOptions(componentKey, { columnOrder });
        this.setState({ columnOrder });
    };
    
    changeColumnWidths = (columnWidths) => {
        cacheTableOptions(componentKey, { columnWidths });
        this.setState({ columnWidths });
    };
    
    changeFilters = (filters) => {
        if (!filters) return;
        
        let filteredRows = [...this.state.allItems].map(this.rowMapper);
        const { searchBy, searchData, filterBy } = filters;
        
        if (searchBy && searchData) {
            filteredRows = filteredRows
                .filter(cg =>
                    cg[searchBy] &&
                    cg[searchBy].toLowerCase().includes(searchData.toLowerCase())
                );
        }
        
        if (filterBy && filterBy !== 'all') {
            if (filterBy === 'active') {
                filteredRows = filteredRows.filter(cg => cg.isActive);
            } else if (filterBy === 'inactive') {
                filteredRows = filteredRows.filter(cg => !cg.isActive);
            }
        }
        
        cacheTableOptions(componentKey, filters);
        this.setState({ rows: filteredRows });
    };
    
    changeSorting = (sorting) => {
        if (!sorting || !sorting.length) return;
        
        const sortBy = sorting[0].columnName;
        const sortDirection = sorting[0].direction;
        const sortedRows = [...this.state.rows]
            .sort((a, b) => compareCaseInsensitive(a[sortBy], b[sortBy], sortDirection));
        
        cacheTableOptions(componentKey, { sorting });
        this.setState({ rows: sortedRows, sorting });
    };
    
    cell = ({ column, style, tableRow, value }) => {
        if (tableRow.row.isSkeletonRow) {
            return <Table.Cell style={style}>{value}</Table.Cell>;
        }
        
        let content = <OverflowTip value={value}>{value}</OverflowTip>;
        
        if (column.name === 'menu') {
            content = this.renderMoreMenu(tableRow);
        } else if (column.name === 'isActive') {
            const className = value ? 'active-1' : 'active-3';
            content = (<Tooltip title={value ? 'Active' : 'Inactive'} placement="left">
                            <CheckIcon className={className} />
                       </Tooltip>);
        }
        content = content === 0 ? '0' : content;
        return <Table.Cell style={style}>{content}</Table.Cell>;
    };
    
    renderMoreMenu = (tableRow) => {
        const { row: { customerGroupId, isActive }} = tableRow;
        
        return (
            <SimpleMenu id={customerGroupId}>
                <MenuItem
                    key="edit-customer-group"
                    component={Link}
                    to={`/add-edit-customer-group/${customerGroupId}`}
                >
                    Edit Customer Group
                </MenuItem>
                {
                    sessionStorage.getItem('product') !== 'VIN Cross Check' &&
                    <MenuItem
                        key="list-customers-by-customer-group"
                        component={Link}
                        to={`/customers/customer-group/${customerGroupId}`}
                    >
                        View Customers
                    </MenuItem>
                }
                {/* <Divider />
                <MenuItem
                    key="deactivate"
                    component={Link}
                    to={this.props.location.pathname}
                    onClick={() => this.handleToggleIsActive(customerGroupId, isActive)}
                >
                    {isActive ? 'Deactivate' : 'Activate'}
                </MenuItem> */}
            </SimpleMenu>
        );
    };
    
    handleToggleIsActive = (id, isActive) => {
        const customerGroup = this.state.allItems.find(cg => cg.customerGroupId === id);
        customerGroup.isActive = !isActive;
        
        this.props.actions.saveCustomerGroup(customerGroup, this.props.config, this);
    };
    
    render() {
        const {
            addLink,
            columns,
            columnOrder,
            columnWidths,
            currentPage,
            filterByOptions,
            initialValues,
            loading,
            pageSize,
            pageSizes,
            rows,
            searchByOptions,
            sorting,
            tableColumnExtensions,
            title,
        } = this.state;
        
        return (
            <Layout
                className="App"
                showMenu
                menuTitle=""
                toolTip="Having problems? Please review the information you have entered to be sure everything is correct.  If you continue to have problems please contact our Customer Service department at (205) 414-2727."
            >
                <Paper style={paperStyle}>
                    {loading && <LinearProgress className="linear-progress-top" />}
                    <Grid
                        rows={rows}
                        columns={columns}
                        getRowId={this.getRowId}
                    >
                        <TableFilters
                            addLink={addLink}
                            changeFilters={this.changeFilters}
                            filterByOptions={filterByOptions}
                            initialValues={initialValues}
                            searchByOptions={searchByOptions}
                            title={title}
                        />
                        
                        {filterByOptions && <IntegratedFiltering />}
                        
                        <SortingState
                            sorting={sorting}
                            onSortingChange={this.changeSorting}
                        />
        
                        <PagingState
                            currentPage={currentPage}
                            onCurrentPageChange={this.changeCurrentPage}
                            pageSize={pageSize}
                            onPageSizeChange={this.changePageSize}
                        />
        
                        <IntegratedSorting />
        
                        <IntegratedPaging />
    
                        <DragDropProvider/>
        
                        <Table
                            columnExtensions={tableColumnExtensions}
                            cellComponent={this.cell}
                        />
    
                        <TableColumnReordering
                            order={columnOrder}
                            onOrderChange={this.changeColumnOrder}
                        />
                        
                        <TableColumnResizing
                            columnWidths={columnWidths}
                            onColumnWidthsChange={this.changeColumnWidths}
                        />
        
                        <TableHeaderRow
                            showSortingControls
                        />
        
                        <PagingPanel pageSizes={pageSizes} />
                    </Grid>
                </Paper>
            </Layout>
        );
    }
}

const reduxToProps = state => ({
    config: state.config.config,
    customerGroups: state.customerGroups
});

const dispatchToProps = dispatch => ({
    actions: {
        getCustomerGroups: (config) => {
            dispatch(getCustomerGroups(config));
        },
        getCustomerGroupData: (customerGroupList, self) => {
            let customerGroups = [];
            let rows = [];
            if (isUserATSysAdmin(localStorage.getItem('customerId'))) {
                customerGroups = customerGroupList;
                rows = customerGroups.map(self.rowMapper);
            }

            self.setState({ loading: false, allItems: customerGroups, rows }, () => {
                self.reapplyTableOptions();
            });
        },
        saveCustomerGroup: (group, config, self) => {
            self.setState({ loading: true });
            
            dispatch(addEditCustomerGroup(group, config))
                .then(() => {
                    self.props.actions.getCustomerGroups(config, self);
                });
        },
    }
});

const ConnectedComponent = connect(reduxToProps, dispatchToProps)(CustomerGroupList);

export default (reduxForm({ form: 'CustomerGroupList' })(ConnectedComponent));


// WEBPACK FOOTER //
// ./src/components/Customer/Customer/CustomerGroupList.js